import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from 'foundations-components/transitional/components/Link';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { findCategoryParent } from '../../config/analyticTools';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnalyticsSuitesBreadCrumbs = ({
  collectionId,
  categoryId,
  subAppKey
}) => {
  const history = useHistory();
  const {
    gates: userAccessGates,
    scopes: userAccessScopes
  } = useSelector(getGatesAndScopes);
  const categoryIA = subAppKey && findCategoryParent(collectionId, subAppKey, userAccessGates, userAccessScopes);
  if (!categoryId && !categoryIA) return null;
  const handleCollectionHomesBackOnClick = parentCategory => {
    history.push(`/collections/${collectionId}/${parentCategory || ''}`);
    const navParentClickedInto = parentCategory || collectionId;
    const conditionalProperties = categoryId ? {
      // The specific category user clicked the back button from
      interactionSource: categoryId,
      whichStage: 'sub-collection-home'
    } : {
      // The specific template user clicked the back button from
      interactionSource: subAppKey,
      whichStage: 'report'
    };
    trackEvent(EVENTS.clickBackButton, Object.assign({
      action: 'exit',
      source: navParentClickedInto
    }, conditionalProperties));
  };
  const parentCategory = categoryIA && categoryIA.get('id');
  const LatestCrumbs = subAppKey ? [/*#__PURE__*/_jsx(Link, {
    onClick: () => handleCollectionHomesBackOnClick(parentCategory),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reports.sidebar.collections.${categoryIA.get('id')}`
    })
  }, "category"), /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reports.suiteContents.${subAppKey}.title`
    })
  }, "template")] : [/*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reports.sidebar.collections.${categoryId}`
    })
  }, "category")];
  return /*#__PURE__*/_jsxs(Breadcrumbs, {
    flush: true,
    marginBlock: "0",
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: () => {
        handleCollectionHomesBackOnClick();
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `reports.collectionHomes.headers.${collectionId}`
      })
    }), LatestCrumbs]
  });
};
export default AnalyticsSuitesBreadCrumbs;